import { AutomationBillingHistoryItemArray } from './../../models/ss-api/responses/automation.billing.history.item';
import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { SortBot } from '../../../app/helpers/sort';
import { Router } from '@angular/router';
import { Angular2Csv } from 'angular2-csv';
import { InvoiceDetailsDialog } from '../../../app/dialogs/invoice.details/invoice.details.dialog';
import { GetAutomationBillingHistoryRequest } from '../../../app/models/ss-api/requests/get.automation.billing.history.request';

import { LicenseManager } from '../../managers/License.manager';

@Component({
    selector: 'automated-billing-report',
    templateUrl: './automated.billing.report.component.html',
    styleUrls: ['./automated.billing.report.component.scss']
})

export class AutomatedBillingReportComponent implements OnInit {
    IsBusy: boolean = false;

    AutomatedBillingItems: AutomationBillingHistoryItemArray;
    AutomatedBillingFilter: string;
    AutomatedBillingStartDate: Date = new Date();
    AutomatedBillingEndDate: Date = new Date();

    constructor(private dialogService: DialogService,
        private api: ssApiService,
        private gb: GlobalService,
        private sweetAlert: SweetAlertService,
        private router: Router) { }

    ngOnInit() {
        this.gb.SetPageTitle('Automated Billing Report');

        this.GetAutomatedBillingHistory();
    }

    sortBy(sortVar1, sortVar2?) {
        this.AutomatedBillingItems = SortBot.SortAuto(this.AutomatedBillingItems, sortVar1, sortVar2);
    }

    onMemberClick(id: number) {
        this.router.navigate(['/member-profile', id]);
    }

    onLicenseClick(key: string) {
        this.IsBusy = true;
        let manager = new LicenseManager()
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(key, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.GetAutomatedBillingHistory();
        })
    }

    onInvoiceClick(Item) {
        let disposable = this.dialogService.addDialog(InvoiceDetailsDialog, {
            invoiceItem: Item,
            memberName: Item.FirstName + ' ' + Item.LastName
        }, { height: 650 }).subscribe(response => {
            disposable.unsubscribe();
        }, error => {
            disposable.unsubscribe();
        });
    }

    GetAutomatedBillingHistory() {
        this.IsBusy = true;
        this.AutomatedBillingStartDate.setHours(0, 0, 0, 0);
        this.AutomatedBillingEndDate.setHours(23, 59, 59, 999);

        let request: GetAutomationBillingHistoryRequest = {
            StartDate: this.AutomatedBillingStartDate,
            EndDate: this.AutomatedBillingEndDate
        }
        let disposable = this.api.GetAutomationBillingHistory(request).subscribe((response) => {
            if (response.Result) {
                this.AutomatedBillingItems = response.Data;
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error Loading Items',
                    text: response.Message
                }).then(() => { }, () => { })
            }
            this.IsBusy = false;
            disposable.unsubscribe();
        })
    }

    ExportToCSV() {
        let options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: ['Invoice ID', 'Invoice Number', 'TransactionID', 'Member Name', 'Designer Name', 'License Key', 'Billing Date', 'CCLast4', 'Total', 'Action', 'RoutineName', 'Processed', 'Result']
        };

        let ExportData = [];

        this.AutomatedBillingItems.forEach(function (item) {
            ExportData.push({
                Invoice_ID: item.Invoice_ID,
                Invoice_Number: item.Invoice.InvoiceNumber,
                TransactionID: item.Invoice.PaymentTransactions[0].GatewayTransactionID,
                MemberName: item.MemberName,
                DesignerName: item.DesignerName,
                LicenseKey: item.LicenseKey,
                BillingDate: item.BillingDateTime,
                CCLast4: item.Invoice.CreditCardLast4,
                Total: item.Invoice.Total,
                Action: item.Action,
                RoutineName: item.RoutineName,
                Processed: item.Processed,
                Result: item.Result
            })
        })

        new Angular2Csv(ExportData, 'AutomatedBillingReport', options);
    }

}
